import { IGroupChatData } from "@home-health-notify/domain";
import { CHAT_DETAILS } from "./PatientChats";
import PatientMoreContent from "./PatientMoreContent";
import PatientLessContent from "./PatientLessContent";
import PatientCompactContent from "./PatientCompactContent";

export function PatientInfoContent(props: {
  showChatDetails: CHAT_DETAILS;
  chatData: IGroupChatData;
}) {
  return (
    <>
      {props.showChatDetails === CHAT_DETAILS.MORE ? (
        <PatientMoreContent chatData={props.chatData} />
      ) : props.showChatDetails === CHAT_DETAILS.COMPACT ? (
        <PatientCompactContent chatData={props.chatData} />
      ) : (
        <PatientLessContent chatData={props.chatData} />
      )}
    </>
  );
}
